import CardFolderTabs, { CardFolderTabsProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: CardFolderTabsProps = {
  activeId: '1',
  children: (
    <CardFolderTabs.Tab id="1" key="1" name="Some tab">
      xxx
    </CardFolderTabs.Tab>
  ),
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as CardFolderTabsProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
